import {makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';

export enum RuleComplexRecipeTypesEnum {
  SLA = 'sla',
  CSAT = 'csat',
  REQUIRED_TAGGING = 'required_tagging',
  // CUSTOM_VIEW = 'custom_view'
}

export const isComplexRecipeId = makeEnumTypeGuard(RuleComplexRecipeTypesEnum);
